<div class="min-h-screen  text-gray-900 flex justify-center bg-[linear-gradient(135deg,hsl(240_100%_4%)_0%,hsl(200_100%_8%)_20%,hsl(195_100%_12%)_40%,hsl(180_95%_15%)_60%,hsl(200_85%_18%)_80%,hsl(240_70%_8%)_100%)]">
    <div class="bg-[linear-gradient(135deg,hsl(240_100%_4%)_0%,hsl(200_100%_8%)_20%,hsl(195_100%_12%)_40%,hsl(180_95%_15%)_60%,hsl(200_85%_18%)_80%,hsl(240_70%_8%)_100%)] m-0 sm:m-10 bg-white shadow sm:rounded-lg flex justify-center flex-1">


        <div class="lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
            <div class="w-60 mx-auto">
                <img src="assets/6b69e5fc-0d9c-40f3-abfc-62866696e1ad.png" alt="Logo" class="w-60 h-52 rounded-[1.5vw]">
            </div>
            <div class="mt-4 flex flex-col items-center">


                <h1 class="text-2xl text-white xl:text-3xl  font-extrabold">
                    Créer un nouveau compte
                </h1>
                <span class="text-white">
                    
                    Vous avez déjà un compte ?
                    <a class="text-indigo-500 hover:text-indigo-700 font-bold " routerLink="/auth/login">
                        Se connecter </a>
                </span>

                <div *ngIf="errorMessage$ | async as error">
                    <p class="text-red-600 bg-red-100 border border-red-400 rounded p-3 mt-4">
                        {{ error }}
                    </p>
                </div>
                <div *ngIf="formError" class="text-red-600 bg-red-100 border border-red-400 rounded p-3 mt-4">
                    {{ formError }}
                </div>
                <div class="w-full flex-1 mt-8">




                    <form class="mx-auto max-w-xs" (ngSubmit)="onSubmit()" ngNativeValidate>
                        <input
                            class="mt-5 w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-[16px] focus:outline-none focus:border-gray-400 focus:bg-white"
                            type="text" placeholder="Nom" name="firstName" id="firstName"
                            [(ngModel)]="user.firstName" />
                        <input
                            class="mt-5 w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-[16px] focus:outline-none focus:border-gray-400 focus:bg-white"
                            type="text" placeholder="Prénom" name="lastName" id="lastName"
                            [(ngModel)]="user.lastName" />

                        <input
                            class="mt-5 w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-[16px] focus:outline-none focus:border-gray-400 focus:bg-white"
                            type="email" placeholder="Email" name="email" id="email" [(ngModel)]="user.email" />
                        <input
                            class="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-[16px] focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                            type="password" placeholder="Mot de passe" name="password" id="password"
                            [(ngModel)]="user.password" />
                        <input
                            class="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-[16px] focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                            type="password" placeholder="Confirmer le mot de passe" id="confirmPassword" name="confirmPassword"
                            [(ngModel)]="confirmPassword" />
                        <button type="submit" [disabled]="isLoading()" [ngClass]="{
                            'bg-[linear-gradient(135deg,hsl(200_95%_45%),hsl(195_100%_50%))] hover:bg-indigo-700': !isLoading(),
                            'bg-gray-400 cursor-not-allowed': isLoading()
                                 }"
                            class="mt-5 tracking-wide font-semibold bg-green-500 text-white w-full py-4 rounded-lg hover:bg-green-700 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
                            <svg class="w-6 h-6 -ml-2" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                                <circle cx="8.5" cy="7" r="4" />
                                <path d="M19 11l2 2-5 5h-2v-2l5-5z" />
                            </svg>
                            <span class="ml-3">S’inscrire</span>
                        </button>


                    </form>
                </div>
            </div>
        </div>

    </div>
</div>